import React, { useEffect, useState } from 'react';
import { BusinessEntityName } from './components/BusinessEntityName';
import { RepresentativeEmail } from './components/RepresentativeEmail';
import { RepresentativeFirstName } from './components/RepresentativeFirstName';
import { RepresentativeMiddleName } from './components/RepresentativeMiddleName';
import { RepresentativeLastName } from './components/RepresentativeLastName';
import { RepresentativeSuffix } from './components/RepresentativeSuffix';
import { StateIncorporated } from './components/StateIncorporated';
import { ICCAAgreementCheckBox } from './components/ICCAAgreementCheckBox';
import { useBrokerNewReferralStore } from '../../state/useBrokerNewReferralStore';
import './scss/_brokerAddNewReferralPanel.scss';
import { SubjectPropertyInState } from './components/SubjectPropertyInState';
import { StateNMLSNumber } from './components/StateNMLSNumber';

interface AddReferralProps {
    onValidationChange: (isValid: boolean) => void;
    onICCAAgreementChange: () => void;
    isOpen: boolean;
}

export const AddReferralPanel: React.FC<AddReferralProps> = ({ onValidationChange, onICCAAgreementChange, isOpen }) => {
    const [repFirstNameValid, set_repFirstNameValid] = useState(false);
    const [repLastNameValid, set_repLastNameValid] = useState(false);
    const [businessEntityNameValid, set_businessEntityNameValid] = useState(false);
    const [stateIncorporatedValid, set_stateIncorporatedValid] = useState(false);
    const [subjectPropertyInStateValid, set_subjectPropertyInStateValid] = useState(false);
    const [propertyNMLSNumberValid, set_propertyNMLSNumberValid] = useState(false);
    const iccaAgreementChecked = useBrokerNewReferralStore((s) => s.referral.iccaAgreement);
    const allRequiredTextFieldsValid =
        repFirstNameValid &&
        repLastNameValid &&
        businessEntityNameValid &&
        stateIncorporatedValid &&
        subjectPropertyInStateValid &&
        propertyNMLSNumberValid;
    const allRequiredFieldsValid =
        repFirstNameValid &&
        repLastNameValid &&
        businessEntityNameValid &&
        stateIncorporatedValid &&
        subjectPropertyInStateValid &&
        propertyNMLSNumberValid &&
        iccaAgreementChecked;

    useEffect(() => {
        if (isOpen) {
            set_repFirstNameValid(false);
            set_repLastNameValid(false);
            set_businessEntityNameValid(false);
            set_stateIncorporatedValid(false);
            set_subjectPropertyInStateValid(false);
            set_propertyNMLSNumberValid(false);
        }
    }, [isOpen]);

    useEffect(() => {
        onValidationChange(allRequiredFieldsValid);
    }, [allRequiredFieldsValid, onValidationChange]);

    return (
        <>
            <h5>Business Information</h5>
            <div className='addReferralPanelSection'>
                <BusinessEntityName
                    required={true}
                    onValidationEvent={(isValid) => set_businessEntityNameValid(isValid)}
                />
                <StateIncorporated
                    required={true}
                    onValidationEvent={(isValid) => set_stateIncorporatedValid(isValid)}
                />
            </div>
            <h5>Representative</h5>
            <div className='addReferralPanelHeaderSubtext'>
                This person should have a 20% or greater ownership interest in the business.
            </div>
            <div className='addReferralPanelSection'>
                <RepresentativeFirstName
                    required={true}
                    onValidationEvent={(isValid) => set_repFirstNameValid(isValid)}
                />
                <RepresentativeMiddleName />
                <RepresentativeLastName
                    required={true}
                    onValidationEvent={(isValid) => set_repLastNameValid(isValid)}
                />
                <RepresentativeSuffix />
                <RepresentativeEmail />
                <SubjectPropertyInState onValidationEvent={(isValid) => set_subjectPropertyInStateValid(isValid)} />
                <StateNMLSNumber onValidationEvent={(isValid) => set_propertyNMLSNumberValid(isValid)} />
            </div>
            <div className='addReferralPanelSection'>
                <ICCAAgreementCheckBox
                    disabled={!allRequiredTextFieldsValid}
                    onChange={onICCAAgreementChange}
                />
            </div>
        </>
    );
};
